import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const CategoryTagsRoutes: Routes = [
  {
    path: "category-tags",
    loadComponent: () =>
      import("./category-tags/category-tags.component").then(
        (m) => m.CategoryTagsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./category-tag-list/category-tag-list.component").then(
            (m) => m.CategoryTagListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./category-tag-form/category-tag-form.component").then(
            (m) => m.CategoryTagFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./category-tag-form/category-tag-form.component").then(
            (m) => m.CategoryTagFormComponent,
          ),
      },
    ],
  },
];
